import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Switch,
  Text,
  TextInput,
} from "@mantine/core";
import { useIsFirstRender } from "@mantine/hooks";
import {
  IconCheck,
  IconFileTypeCsv,
  IconSearch,
  IconX,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  keySearchCompareOrder,
  keySearchCompareVT,
  repositoryMdm,
} from "../../../_base/_const/_constVar";
import { changeSearchValue } from "../../../_base/helper/FunctionHelper";
import { _localization } from "../../../config/location";
import { green } from "../../../const/variables";
import { MessageResponse } from "../../../model/MessageResponse";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { utils, writeFile } from "xlsx";

const CompareVT = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 100,
  });

  const firstRender = useIsFirstRender();
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const _searchJson = (() => {
    try {
      const storedValue = sessionStorage.getItem(keySearchCompareOrder);
      return storedValue ? JSON.parse(storedValue) : null;
    } catch (error) {
      console.error("Lỗi khi parse JSON từ sessionStorage:", error);
      return null;
    }
  })();

  const [search, setSearch] = useState({
    KeySearch:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.KeySearch
        : "",
    IsExist:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.IsExist
        : "false",
    IsDifferenceWarranty:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.IsDifferenceWarranty
        : "",
    IsDifferenceWarrantyVendor:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.IsDifferenceWarrantyVendor
        : "",
    IsDifferenceWarrantyName:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.IsDifferenceWarrantyName
        : "",
    IsDifferenceOtherWarranty:
      firstRender && _searchJson && checkedPinSearch
        ? _searchJson.IsDifferenceOtherWarranty
        : "",
  });

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ renderedCellValue, row }) => (
          <Badge
            radius="sm"
            variant="dot"
            size="lg"
            style={{ cursor: "pointer" }}
            color={renderedCellValue === null ? "red" : green.base}
          >
            {renderedCellValue === null
              ? "Không tồn tại dưới POS"
              : renderedCellValue}
          </Badge>
        ),
        size: 250,
      },
      {
        accessorKey: "pItemName",
        header: "Tên sản phẩm (POS)",
        size: 450,
      },
      {
        accessorKey: "pWarrantyVendor",
        header: "Bảo hành nhà cung cấp (POS)",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text fw={500} size="12.5px">
              {renderedCellValue} tháng
            </Text>
          ) : (
            <></>
          ),
        size: 275,
      },
      {
        accessorKey: "pWarranty",
        header: "Bảo hành tại HACOM (POS)",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text fw={500} size="12.5px">
              {renderedCellValue} tháng
            </Text>
          ) : (
            <></>
          ),
        size: 275,
      },
      {
        accessorKey: "pOtherWarranty",
        header: "Bảo hành tại Web (POS)",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text fw={500} size="12.5px">
              {renderedCellValue} tháng
            </Text>
          ) : (
            <></>
          ),
        size: 275,
      },
      {
        accessorKey: "aItemName",
        header: "Tên sản phẩm (ASIA)",
        size: 450,
      },
      {
        accessorKey: "aWarrantyVendor",
        header: "Bảo hành nhà cung cấp (ASIA)",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text fw={500} size="12.5px">
              {renderedCellValue} tháng
            </Text>
          ) : (
            <></>
          ),
        size: 275,
      },
      {
        accessorKey: "aWarranty",
        header: "Bảo hành tại HACOM (ASIA)",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text fw={500} size="12.5px">
              {renderedCellValue} tháng
            </Text>
          ) : (
            <></>
          ),
        size: 275,
      },
      {
        accessorKey: "aOtherWarranty",
        header: "Bảo hành tại Web (ASIA)",
        Cell: ({ renderedCellValue }) =>
          renderedCellValue || renderedCellValue === 0 ? (
            <Text fw={500} size="12.5px">
              {renderedCellValue} tháng
            </Text>
          ) : (
            <></>
          ),
        size: 275,
      },
    ],
    []
  );

  const fetchData = async (exportExcel?: boolean) => {
    if (!exportExcel) {
      setIsLoading(true);
      setIsRefetching(true);
      setIsError(false);
    }

    const keySearchObj = {
      KeySearch: search.KeySearch,
    };

    try {
      let url = `/api/v1/CompareAsiaPos/so-sanh-san_pham?Skip=${
        pagination.pageSize * pagination.pageIndex
      }&Take=${exportExcel ? rowCount : pagination.pageSize}&IsDifference=true`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (value?.length > 0 && (value !== "false" || key === "IsExist")) {
          params.append(key, String(value));
        }
      });
      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        if (exportExcel) {
          const data = result.map((item: any) => ({
            "Mã sản phẩm": item.itemCode,
            "Tên sản phẩm (POS)": item.pItemName,
            "Bảo hành nhà cung cấp (POS)": item.pWarrantyVendor,
            "Bảo hành tại HACOM (POS)": item.pWarranty,
            "Tên sản phẩm (ASIA)": item.aItemName,
            "Bảo hành nhà cung cấp (ASIA)": item.aWarrantyVendor,
            "Bảo hành tại HACOM (ASIA)": item.aWarranty,
          }));

          const wb = utils.book_new();
          const ws = utils.json_to_sheet(data);

          const colWidths = [];
          const range = utils.decode_range(ws["!ref"] || "A1:A1");

          for (let col = range.s.c; col <= range.e.c; col++) {
            let maxLength = 0;

            for (let row = range.s.r; row <= range.e.r; row++) {
              const cellAddress = utils.encode_cell({ r: row, c: col });
              const cell = ws[cellAddress];

              if (cell && cell.v) {
                const cellLength = cell.v.toString().length;
                maxLength = Math.max(maxLength, cellLength);
              }
            }

            colWidths.push({ width: Math.min(maxLength + 2, 50) });
          }

          ws["!cols"] = colWidths;

          utils.book_append_sheet(wb, ws, "Users");

          writeFile(wb, "danh_sach_doi_chieu_vat_tu.xlsx");
        } else {
          setData(result);
          setRowCount(res.totalCount);
          table.resetRowSelection();
        }
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      sessionStorage.setItem(keySearchCompareVT, JSON.stringify(keySearchObj));
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (230 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-numbers", "itemCode"],
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["50", "100", "200"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  return (
    <Box w={"100%"}>
      <Flex
        w={"100%"}
        gap={"md"}
        wrap={"wrap"}
        justify={"space-between"}
        align={"center"}
      >
        <_breadcrumb></_breadcrumb>
        <Button
          leftSection={<IconFileTypeCsv size={16} />}
          disabled={
            data.length === 0 ||
            Number(rowCount) === 0 ||
            Number(rowCount) > 5000
          }
          onClick={() => fetchData(true)}
        >
          Export Excel
        </Button>
      </Flex>
      <Grid align="center">
        <Grid.Col span={{ base: 12, md: 6, lg: 2 }}>
          <TextInput
            placeholder="Nhập từ khóa"
            leftSection={<IconSearch size={14} color="#15aabf" />}
            value={search?.KeySearch}
            onChange={(e) =>
              changeSearchValue(e.currentTarget.value, "KeySearch", setSearch)
            }
          />
        </Grid.Col>
        <Grid.Col span={{ base: 12, md: 6, lg: 8 }}>
          <Flex justify={"start"} align={"center"} gap={"md"}>
            <Switch
              onLabel={"Không tồn tại trên POS"}
              offLabel={"Tồn tại trên POS"}
              checked={search.IsExist === "true"}
              color="red"
              size="lg"
              onClick={() =>
                changeSearchValue(
                  search.IsExist === "true" ? "false" : "true",
                  "IsExist",
                  setSearch
                )
              }
              thumbIcon={
                search.IsExist !== "true" ? (
                  <IconCheck
                    size={12}
                    color="var(--mantine-color-teal-6)"
                    stroke={3}
                  />
                ) : (
                  <IconX
                    size={12}
                    color="var(--mantine-color-red-6)"
                    stroke={3}
                  />
                )
              }
            />
            <Switch
              onLabel={"Lệch bảo hành HACOM"}
              offLabel={"Không lệch bảo hành HACOM"}
              checked={search.IsDifferenceWarranty === "true"}
              color="red"
              size="lg"
              onClick={() =>
                changeSearchValue(
                  search.IsDifferenceWarranty === "true" ? "false" : "true",
                  "IsDifferenceWarranty",
                  setSearch
                )
              }
              thumbIcon={
                search.IsDifferenceWarranty !== "true" ? (
                  <IconCheck
                    size={12}
                    color="var(--mantine-color-teal-6)"
                    stroke={3}
                  />
                ) : (
                  <IconX
                    size={12}
                    color="var(--mantine-color-red-6)"
                    stroke={3}
                  />
                )
              }
            />
            <Switch
              onLabel={"Lệch bảo hành NCC"}
              offLabel={"Không lệch bảo hành NCC"}
              checked={search.IsDifferenceWarrantyVendor === "true"}
              color="red"
              size="lg"
              onClick={() =>
                changeSearchValue(
                  search.IsDifferenceWarrantyVendor === "true"
                    ? "false"
                    : "true",
                  "IsDifferenceWarrantyVendor",
                  setSearch
                )
              }
              thumbIcon={
                search.IsDifferenceWarrantyVendor !== "true" ? (
                  <IconCheck
                    size={12}
                    color="var(--mantine-color-teal-6)"
                    stroke={3}
                  />
                ) : (
                  <IconX
                    size={12}
                    color="var(--mantine-color-red-6)"
                    stroke={3}
                  />
                )
              }
            />
            <Switch
              onLabel={"Lệch tên sản phẩm"}
              offLabel={"Không lệch tên sản phẩm"}
              checked={search.IsDifferenceWarrantyName === "true"}
              color="red"
              size="lg"
              onClick={() =>
                changeSearchValue(
                  search.IsDifferenceWarrantyName === "true" ? "false" : "true",
                  "IsDifferenceWarrantyName",
                  setSearch
                )
              }
              thumbIcon={
                search.IsDifferenceWarrantyName !== "true" ? (
                  <IconCheck
                    size={12}
                    color="var(--mantine-color-teal-6)"
                    stroke={3}
                  />
                ) : (
                  <IconX
                    size={12}
                    color="var(--mantine-color-red-6)"
                    stroke={3}
                  />
                )
              }
            />
            <Switch
              onLabel={"Lệch bảo hành trên web"}
              offLabel={"Không lệch bảo hành trên web"}
              checked={search.IsDifferenceOtherWarranty === "true"}
              color="red"
              size="lg"
              onClick={() =>
                changeSearchValue(
                  search.IsDifferenceOtherWarranty === "true"
                    ? "false"
                    : "true",
                  "IsDifferenceOtherWarranty",
                  setSearch
                )
              }
              thumbIcon={
                search.IsDifferenceOtherWarranty !== "true" ? (
                  <IconCheck
                    size={12}
                    color="var(--mantine-color-teal-6)"
                    stroke={3}
                  />
                ) : (
                  <IconX
                    size={12}
                    color="var(--mantine-color-red-6)"
                    stroke={3}
                  />
                )
              }
            />
            <Button
              leftSection={<IconSearch color="#15aabf" size={14} />}
              onClick={() => fetchData()}
            >
              Tìm kiếm
            </Button>
          </Flex>
        </Grid.Col>
      </Grid>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default CompareVT;
